import { defineComponent as _defineComponent } from 'vue'
import CiButton from "@components/base/button.vue";
import ScrollSnapSlider from "@components/base/scroll-snap-slider.vue";
import CiContentTile from "@components/contents/ContentTile.vue";
import { useInternalTracking } from "@composables/internalTracking";


export default /*#__PURE__*/_defineComponent({
  __name: 'news',
  props: {
    contents: null,
    loading: { type: Boolean, default: true }
  },
  emits: ["tracking-click"],
  setup(__props: any, { emit }: { emit: ({ (event: "tracking-click", options: InternalTracking.TrackClickOptions): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { contents: Indexable, loading: boolean };



const { propagateTrackClick } = useInternalTracking(emit, "News");

const propagateTrackClickWithEvent = async (options: InternalTracking.TrackClickOptions, eventValue: number) => {
  options.eventValue = eventValue;
  propagateTrackClick(options);
};

return { __sfc: true,props, emit, propagateTrackClick, propagateTrackClickWithEvent, CiButton, ScrollSnapSlider, CiContentTile }
}

})